export default {
    title: '惠招E站',
    coin: '惠点',
    vip:'我的订单',
    description: '惠招E站是专注招标采购领域的知识共享平台，实时更新政策法规、提供招标采购文件在线模版编制，通过业务视频、每日一问、大模型智能问答功能深度解析行业动态与专业知识。以全方位、智能化服务赋能用户，助力招投标行业的高效运作与持续发展。'
};